import { render } from "./AirplaneSeats.vue?vue&type=template&id=5e7dfe39&scoped=true"
import script from "./AirplaneSeats.vue?vue&type=script&lang=js"
export * from "./AirplaneSeats.vue?vue&type=script&lang=js"

import "./AirplaneSeats.vue?vue&type=style&index=0&id=5e7dfe39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7dfe39"]])

export default __exports__